import { useCurrentSessionUser } from '../session';

type UseShowStorylineAdminSettings = () => boolean;
export const useShowStorylineAdminSettings: UseShowStorylineAdminSettings = () => {
  const { isNetworkAdmin } = useCurrentSessionUser();

  return isNetworkAdmin;
};
